module.exports = __webpack_public_path__ + "img/1485435369.067fe72d.jpg";